import React, { ButtonHTMLAttributes } from 'react';

export interface VoxelSubtleButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'title' | 'color'> {
  label?: React.ReactNode;
  active?: boolean;
  extraClickSpace?: boolean;
  truncateClass?: string;
  color?: 'white' | 'gray';
}

// It's designed so that the click area is slightly larger than the button itself
// This helps because the button itself is sometimes rather small
export const VoxelSubtleButton = React.forwardRef<HTMLButtonElement, VoxelSubtleButtonProps>(
  (
    {
      type = 'button',
      active,
      label,
      className,
      extraClickSpace = true,
      color = 'white',
      ...buttonProps
    },
    ref
  ) => {
    return (
      <button
        className={`
            ${extraClickSpace && 'py-3 px-2'}
            group/subtle-button
            !w-fit
            ${className} 
    `}
        ref={ref}
        {...buttonProps}
      >
        {/* This is what looks like the button */}
        {/* ... although the outside is clickable */}
        <span
          className={`
            px-1 py-0.5 rounded 
            text-xs 
            ${
              !active &&
              color === 'gray' &&
              `
            bg-voxel-gray-50 text-voxel-gray-600
            ring-1 ring-inset ring-voxel-gray-200 
            group-hover/subtle-button:text-voxel-gray-600
              group-hover/subtle-button:ring-1 group-hover/subtle-button:ring-inset 
              group-hover/subtle-button:ring-voxel-gray-500 
          `
            }
            ${
              !active &&
              color === 'white' &&
              `
            bg-voxel-white text-voxel-gray-600
            ring-1 ring-inset ring-voxel-gray-200 
            group-hover/subtle-button:text-voxel-gray-600
              group-hover/subtle-button:ring-1 group-hover/subtle-button:ring-inset 
              group-hover/subtle-button:ring-voxel-gray-500 
          `
            }
            ${
              active &&
              color === 'gray' &&
              `
            bg-voxel-gray-200
            text-voxel-gray-900
            ring-1 ring-inset ring-voxel-gray-200
            `
            } 
            ${
              active &&
              color === 'white' &&
              `
            bg-voxel-gray-100
            text-voxel-gray-900
            ring-1 ring-inset ring-voxel-gray-200
            `
            } 
            
        `}
        >
          {label}
        </span>
      </button>
    );
  }
);

export default VoxelSubtleButton;
